import { eventBus, events } from '@/eventBus.js';
import { trans } from '@/mixins/i18n.js';
import { useConnectivityStore, type ConnectivityState } from '@/stores/connectivity';
import { storeToRefs } from 'pinia';
import { onBeforeUnmount, onMounted, ref, watch } from 'vue';

export function useConnectivityFlash(): void {
    const connectivity = useConnectivityStore();
    const { state } = storeToRefs(connectivity);

    const seenOnlineOnce = ref(false);
    let stop: (() => void) | null = null;

    function handleTransition(newValue: ConnectivityState, oldValue: ConnectivityState | undefined): void {
        if (newValue === 'online') {
            if (!seenOnlineOnce.value) {
                seenOnlineOnce.value = true;
                return;
            }
            eventBus.$emit(events.presentFlashMessage, {
                payload: { message: trans('connectivity.flash.restored') },
            });
            return;
        }

        if (seenOnlineOnce.value && oldValue === 'online') {
            eventBus.$emit(events.presentFlashMessage, {
                payload: { message: trans('connectivity.flash.lost'), status: 'error' },
            });
        }
    }

    onMounted(() => {
        if (state.value === 'online') {
            seenOnlineOnce.value = true;
        }
        stop = watch(state, handleTransition);
    });

    onBeforeUnmount(() => {
        stop?.();
        stop = null;
    });
}
